var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JurnalList',{attrs:{"showTabs":"","jenisJurnal":"1","title":_vm.title,"routeInput":_vm.input,"routeEdit":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }